// Secure storage utility with localStorage fallback for demo
class SecureStorage {
  constructor() {
    this.sessionTimeout = 30 * 60 * 1000; // 30 minutes
  }

  // Set item with expiration
  setItem(key, value, expirationMs = this.sessionTimeout) {
    const item = {
      value: JSON.stringify(value),
      expiry: Date.now() + expirationMs,
    };

    try {
      localStorage.setItem(key, JSON.stringify(item));
    } catch (error) {
      console.warn('localStorage not available, data will not persist');
    }
  }

  // Get item if not expired
  getItem(key) {
    try {
      const itemStr = localStorage.getItem(key);
      if (!itemStr) return null;

      const item = JSON.parse(itemStr);
      if (Date.now() > item.expiry) {
        localStorage.removeItem(key);
        return null;
      }

      return JSON.parse(item.value);
    } catch (error) {
      console.warn('Error reading from localStorage:', error);
      return null;
    }
  }

  // Remove item
  removeItem(key) {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.warn('Error removing from localStorage:', error);
    }
  }

  // Clear all items
  clear() {
    try {
      localStorage.clear();
    } catch (error) {
      console.warn('Error clearing localStorage:', error);
    }
  }

  // Check if item exists and is valid
  hasItem(key) {
    return this.getItem(key) !== null;
  }
}

// Create singleton instance
const secureStorage = new SecureStorage();

export default secureStorage;